import { render, staticRenderFns } from "./AdminPeriodos.vue?vue&type=template&id=eb9eb928&"
import script from "./AdminPeriodos.vue?vue&type=script&lang=js&"
export * from "./AdminPeriodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports